import React, { useMemo, useCallback, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/pro-light-svg-icons";

import MenuDropdown from "../../../../components/nav/MenuDropdown/MenuDropdown";
import MenuTrigger from "../../../../components/nav/MenuTrigger/MenuTrigger";
import Text from "../../../../components/common/Text/Text";

import locales from "../../../../lib/locale";
import { LocaleContext } from "../../../../lib/util/LocaleUtils";
import * as strings from "../../../../strings";

const menuItems = Object.keys(locales)
	.filter((localeKey) => !locales[localeKey].options.technical)
	.map((localeKey) => {
		const localeData = locales[localeKey];

		return {
			id: localeKey,
			displayName: localeData.name,
			pathName: "#",
			noRedirect: true,
		};
	});

interface NavLocaleProps {
	onOpenChange?: (open: boolean) => void;
	onSelect?: (code: string) => void;
	localChangeOnly?: boolean;
}

const NavLocale: React.FC<NavLocaleProps> = (props) => {
	const { onOpenChange, onSelect, localChangeOnly } = props;
	const localeContext = useContext(LocaleContext);

	const overlay = useMemo(
		() => ({
			tooltipReference: (
				<MenuTrigger>
					<Text inline={true}>{strings.NAVIGATION_LANGUAGE}</Text>
				</MenuTrigger>
			),
		}),
		[],
	);

	const handleLocaleSelect = useCallback(
		(item) => {
			if (!localChangeOnly) {
				localeContext.setCode(item.id);
			}

			if (onSelect) {
				onSelect(item.id);
			}
		},
		[localeContext, onSelect, localChangeOnly],
	);

	return (
		<MenuDropdown
			items={menuItems}
			referenceClassName={"Navigation__locale"}
			tooltipClassName={"Navigation__locale-menu"}
			overlay={overlay}
			selected={localeContext.code}
			onSelect={handleLocaleSelect}
			onVisibleChange={onOpenChange}
			placement={"bottom-end"}
		>
			<FontAwesomeIcon icon={faGlobe} className={"navigation-locale"} />
		</MenuDropdown>
	);
};

export default NavLocale;
